var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.759,
    height: 139.759,
    viewBox: "0 0 139.759 139.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#5fd8a6}.cls-2{fill:#f4f4fb}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-big",
    transform: "translate(-84.635 -374.087)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_25",
    cx: 69.88,
    cy: 69.88,
    r: 69.88,
    className: "cls-1",
    "data-name": "Elipse 25",
    transform: "translate(84.635 374.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    d: "M194.36 423.716l-11.7-11.094-38.3 40.365-17.193-16.316-11.092 11.685 23.032 21.829 5.919 5.493z",
    className: "cls-2",
    "data-name": "Trazado 68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBig);
export default __webpack_public_path__ + "static/media/icon-check-big.dbf15b4c83ef088f17b0c69aa1d8d339.svg";
export { ForwardRef as ReactComponent };